import { createAction } from "redux-actions";

// GET ALL SCHEMES
export const GET_ALL_SCHEMES = "GET_ALL_SCHEMES";
export const getAllSchemes = createAction(GET_ALL_SCHEMES);

export const GET_ALL_SCHEMES_FAILURE = "GET_ALL_SCHEMES_FAILURE";
export const getAllSchemesFailure = createAction(GET_ALL_SCHEMES_FAILURE);

export const GET_ALL_SCHEMES_SUCCESS = "GET_ALL_SCHEMES_SUCCESS";
export const getAllSchemesSuccess = createAction(GET_ALL_SCHEMES_SUCCESS);

// ADD SCHEME
export const ADD_SCHEME = "ADD_SCHEME";
export const addScheme = createAction(ADD_SCHEME);

export const ADD_SCHEME_FAILURE = "ADD_SCHEME_FAILURE";
export const addSchemeFailure = createAction(ADD_SCHEME_FAILURE);

export const ADD_SCHEME_SUCCESS = "ADD_SCHEME_SUCCESS";
export const addSchemeSuccess = createAction(ADD_SCHEME_SUCCESS);

// DELETE SCHEME
export const DELETE_SCHEME = "DELETE_SCHEME";
export const deleteScheme = createAction(DELETE_SCHEME);

export const DELETE_SCHEME_FAILURE = "DELETE_SCHEME_FAILURE";
export const deleteSchemeFailure = createAction(DELETE_SCHEME_FAILURE);

export const DELETE_SCHEME_SUCCESS = "DELETE_SCHEME_SUCCESS";
export const deleteSchemeSuccess = createAction(DELETE_SCHEME_SUCCESS);

// UPDATE SCHEME STATUS
export const UPDATE_SCHEME_STATUS = "UPDATE_SCHEME_STATUS";
export const updateSchemeStatus = createAction(UPDATE_SCHEME_STATUS);

export const UPDATE_SCHEME_STATUS_FAILURE = "UPDATE_SCHEME_STATUS_FAILURE";
export const updateSchemeStatusFailure = createAction(
  UPDATE_SCHEME_STATUS_FAILURE
);

export const UPDATE_SCHEME_STATUS_SUCCESS = "UPDATE_SCHEME_STATUS_SUCCESS";
export const updateSchemeStatusSuccess = createAction(
  UPDATE_SCHEME_STATUS_SUCCESS
);

// UPDATE SCHEME
export const UPDATE_SCHEME = "UPDATE_SCHEME";
export const updateScheme = createAction(UPDATE_SCHEME);

export const UPDATE_SCHEME_FAILURE = "UPDATE_SCHEME_FAILURE";
export const updateSchemeFailure = createAction(UPDATE_SCHEME_FAILURE);

export const UPDATE_SCHEME_SUCCESS = "UPDATE_SCHEME_SUCCESS";
export const updateSchemeSuccess = createAction(UPDATE_SCHEME_SUCCESS);

// CLEAR ADD SCHEME
export const CLEAR_ADD_SCHEME = "CLEAR_ADD_SCHEME";
export const clearAddScheme = createAction(CLEAR_ADD_SCHEME);

// GET USER SCHEME
export const GET_USER_SCHEME = "GET_USER_SCHEME";
export const getUserSchemes = createAction(GET_USER_SCHEME);

export const GET_USER_SCHEME_FAILURE = "GET_USER_SCHEME_FAILURE";
export const getUserSchemesFailure = createAction(GET_USER_SCHEME_FAILURE);

export const GET_USER_SCHEME_SUCCESS = "GET_USER_SCHEME_SUCCESS";
export const getUserSchemesSuccess = createAction(GET_USER_SCHEME_SUCCESS);

// GET ALL SCHEMES
export const GET_SCHEMES_BY_ID = "GET_SCHEMES_BY_ID";
export const getSchemesById = createAction(GET_SCHEMES_BY_ID);

export const GET_SCHEMES_BY_ID_FAILURE = "GET_SCHEMES_BY_ID_FAILURE";
export const getSchemesByIdFailure = createAction(GET_SCHEMES_BY_ID_FAILURE);

export const GET_SCHEMES_BY_ID_SUCCESS = "GET_SCHEMES_BY_ID_SUCCESS";
export const getSchemesByIdSuccess = createAction(GET_SCHEMES_BY_ID_SUCCESS);

// SYCN UPLOAD
export const SYNC_UPLOAD = "SYNC_UPLOAD";
export const syncUpload = createAction(SYNC_UPLOAD);

export const SYNC_UPLOAD_FAILURE = "SYNC_UPLOAD_FAILURE";
export const syncUploadFailure = createAction(SYNC_UPLOAD_FAILURE);

export const SYNC_UPLOAD_SUCCESS = "SYNC_UPLOAD_SUCCESS";
export const syncUploadSuccess = createAction(SYNC_UPLOAD_SUCCESS);

/// ******* New Scheme Actions ************* /////
// GET ALL NEW SCHEMES
export const GET_ALL_NEW_SCHEMES = "GET_ALL_NEW_SCHEMES";
export const getAllNewSchemes = createAction(GET_ALL_NEW_SCHEMES);

export const GET_ALL_NEW_SCHEMES_FAILURE = "GET_ALL_NEW_SCHEMES_FAILURE";
export const getAllNewSchemesFailure = createAction(
  GET_ALL_NEW_SCHEMES_FAILURE
);

export const GET_ALL_NEW_SCHEMES_SUCCESS = "GET_ALL_NEW_SCHEMES_SUCCESS";
export const getAllNewSchemesSuccess = createAction(
  GET_ALL_NEW_SCHEMES_SUCCESS
);

// GET NEW SCHEMES BY ID
export const GET_NEW_SCHEMES_BY_ID = "GET_NEW_SCHEMES_BY_ID";
export const getNewSchemesById = createAction(GET_NEW_SCHEMES_BY_ID);

export const GET_NEW_SCHEMES_BY_ID_FAILURE = "GET_NEW_SCHEMES_BY_ID_FAILURE";
export const getNewSchemesByIdFailure = createAction(
  GET_NEW_SCHEMES_BY_ID_FAILURE
);

export const GET_NEW_SCHEMES_BY_ID_SUCCESS = "GET_NEW_SCHEMES_BY_ID_SUCCESS";
export const getNewSchemesByIdSuccess = createAction(
  GET_NEW_SCHEMES_BY_ID_SUCCESS
);

// ADD/UPDATE NEW SCHEME
export const ADD_UPDATE_NEW_SCHEME = "ADD_UPDATE_NEW_SCHEME";
export const addUpdateNewScheme = createAction(ADD_UPDATE_NEW_SCHEME);

export const ADD_UPDATE_NEW_SCHEME_FAILURE = "ADD_UPDATE_NEW_SCHEME_FAILURE";
export const addUpdateNewSchemeFailure = createAction(
  ADD_UPDATE_NEW_SCHEME_FAILURE
);

export const ADD_UPDATE_NEW_SCHEME_SUCCESS = "ADD_UPDATE_NEW_SCHEME_SUCCESS";
export const addUpdateNewSchemeSuccess = createAction(
  ADD_UPDATE_NEW_SCHEME_SUCCESS
);

// Send Test  Notification
export const SEND_TEST_NOTIFICATION = "SEND_TEST_NOTIFICATION";
export const sendTestNotification = createAction(SEND_TEST_NOTIFICATION);

// GET DEEP LINKS
export const GET_DEEP_LINKS = "GET_DEEP_LINKS";
export const getAllDeepLinks = createAction(GET_DEEP_LINKS);

export const GET_DEEP_LINKS_FAILURE = "GET_DEEP_LINKS_FAILURE";
export const getAllDeepLinksFailure = createAction(GET_DEEP_LINKS_FAILURE);

export const GET_DEEP_LINKS_SUCCESS = "GET_DEEP_LINKS_SUCCESS";
export const getAllDeepLinksSuccess = createAction(GET_DEEP_LINKS_SUCCESS);

// GET APP IDs
export const GET_ALL_APP_IDS = "GET_ALL_APP_IDS";
export const getAllAppIds = createAction(GET_ALL_APP_IDS);

export const GET_ALL_APP_IDS_SUCCESS = "GET_ALL_APP_IDS_SUCCESS";
export const getAllAppIdsSuccess = createAction(GET_ALL_APP_IDS_SUCCESS);

export const GET_ALL_APP_IDS_FAILURE = "GET_ALL_APP_IDS_FAILURE";
export const getAllAppIdsFailure = createAction(GET_ALL_APP_IDS_FAILURE);
